import { Component, OnInit } from '@angular/core';
import { LuTypeaheadItem } from '../lu-typeahead-items/lu-typeahead-item';
import { LuBaseTypeahedBaseOptions, LuTypeaheadType } from '../lu-typeahead.models';

export class LuTypeaheadItemTitleLabelOptions extends LuBaseTypeahedBaseOptions {
	primaryField: IItemLabelPrimaryField;
	secondaryField: IItemLabelSecondaryField;
	type: LuTypeaheadType = LuTypeaheadType.PRIMARY_SECONDARY;

	constructor(primaryField: IItemLabelPrimaryField, secondaryField?: IItemLabelSecondaryField) {
		super();
		this.primaryField = primaryField;
		this.secondaryField = secondaryField;
	}
}

export interface IItemLabelPrimaryField {
	field: string;
	class?: string;
	formatter?: any;
}

export interface IItemLabelSecondaryField {
	field: string;
	class?: string;
	formatter?: any;
}

interface Field {
	value: string;
	class?: string;
}

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-typeahead-item-title-label',
	templateUrl: './lu-typeahead-item-title-label.component.html',
	styleUrls: ['./lu-typeahead-item-title-label.component.scss']
})
export class LuTypeaheadItemTitleLabelComponent extends LuTypeaheadItem implements OnInit {
	primaryField: Field;
	secondaryField: Field;
	options: LuTypeaheadItemTitleLabelOptions;
	constructor() {
		super();
	}

	ngOnInit(): void {
		this.primaryField = this.buildPrimaryField();
		if (!!this.options.secondaryField) {
			this.secondaryField = this.buildSecondaryField();
		}
	}

	buildPrimaryField(): Field {
		const { formatter, field } = this.options.primaryField;
		let value = '';
		if (!!formatter) {
			value = formatter(this.data, this.data[field]);
		} else {
			value = field ? this.data[field] : this.data;
		}

		return {
			value,
			class: this.options.primaryField.class
		};
	}

	buildSecondaryField(): Field {
		const { formatter, field } = this.options.secondaryField;
		let value = '';
		if (!!formatter) {
			value = formatter(this.data, this.data[field]);
		} else {
			value = this.data[field];
		}
		return {
			value,
			class: this.options.secondaryField.class
		};
	}
}
